(function () {
  if (window.__grannyIdleMascotInit) return;
  window.__grannyIdleMascotInit = true;

  var FIRST_MIN_MS = 30000;
  var FIRST_MAX_MS = 35000;
  var SECOND_DELAY_MS = 90000;
  var REPEAT_MIN_MS = 90000;
  var REPEAT_MAX_MS = 150000;
  var VISIBLE_MS = 8000;
  var SECOND_VISIBLE_MS = 10000;

  var firstMessages = {
    en: [
      "Nothing caught your eye yet? It's okay. Commitment is scary.",
      'So... are we shopping or just hanging out?',
      'Still browsing? I also avoid making decisions.',
      "Take your time. I've already accepted my fate.",
      "I'm starting to think you're here just to judge my crochet.",
      "Come on... my mortgage isn't going to pay itself."
    ],
    ka: [
      'ვაა, ვერაფერი აარჩიე? ჩემზე წუნია ვინმე თუ იყო არ მეგონა...',
      'აბაა.. ვშოპინგობთ, თუ უბრალოდ ვტკბებით ჩემი ჭაობის სილამაზით?',
      'კიდევ ათვალიერებ? მეც მიჭირს ხოლმე გადააწყვეტილებების მიღება.',
      'მიდი,მიდი, არ იჩქარო. მე უკვე შევეგუე ჩემს ბედს.',
      'ნუ მაფიქრებინებ, რომ აქ მხოლოდ ჩემი პროდუქტების გასაკრიტიკებლად ხარ... ტფუ ტფუ ტფუ, თვალი არ მეცეს!!',
      'კაი ახლა.. იპოთეკა მაქვს გადასახდელი...'
    ]
  };

  var secondMessage = {
    en: "We've been together for a minute and a half now. I like your company... but statistically I'd also enjoy a purchase.",
    ka: 'უკვე წუთნახევარია მიყურებ. კაია შენთან ერთად, მაგრამ...  მაგრამ სტატისტიკურად შენს კალათაშო ჩემი ნივთების ჩაგდებაც კარგი იქნებოდა.'
  };

  var stopped = false;
  var drawerOpen = false;
  var visibleTimer = null;

  // --- a setTimeout wrapper that can be paused/resumed with its remaining time intact ---
  var pending = null; // { remaining, startedAt, callback, timeoutId, running }

  function clearPending() {
    if (pending && pending.timeoutId) clearTimeout(pending.timeoutId);
    pending = null;
  }

  function armPending(delay, callback) {
    clearPending();
    pending = { remaining: delay, startedAt: Date.now(), callback: callback, running: true };
    pending.timeoutId = setTimeout(function () {
      pending = null;
      callback();
    }, delay);
  }

  function pausePending() {
    if (!pending || !pending.running) return;
    clearTimeout(pending.timeoutId);
    var elapsed = Date.now() - pending.startedAt;
    pending.remaining = Math.max(pending.remaining - elapsed, 0);
    pending.running = false;
  }

  function resumePending() {
    if (!pending || pending.running) return;
    var callback = pending.callback;
    var remaining = pending.remaining;
    pending.running = true;
    pending.startedAt = Date.now();
    pending.timeoutId = setTimeout(function () {
      pending = null;
      callback();
    }, remaining);
  }

  function rand(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function isGeorgianPage() {
    return document.documentElement.lang && document.documentElement.lang.indexOf('ka') === 0;
  }

  function pickFirstMessage() {
    var list = isGeorgianPage() ? firstMessages.ka : firstMessages.en;
    return list[Math.floor(Math.random() * list.length)];
  }

  function getSecondMessage() {
    return isGeorgianPage() ? secondMessage.ka : secondMessage.en;
  }

  function getEls() {
    var root = document.getElementById('granny-idle-mascot');
    if (!root) return null;
    return { root: root, text: root.querySelector('.granny-idle-mascot__text') };
  }

  function hide() {
    var els = getEls();
    if (!els) return;
    els.root.classList.remove('is-visible');
    els.root.setAttribute('aria-hidden', 'true');
  }

  function show(message, duration) {
    var els = getEls();
    if (!els) return;

    els.text.textContent = message;
    els.root.classList.add('is-visible');
    els.root.setAttribute('aria-hidden', 'false');

    clearTimeout(visibleTimer);
    visibleTimer = setTimeout(hide, duration);
  }

  function stop() {
    if (stopped) return;
    stopped = true;
    clearTimeout(visibleTimer);
    clearPending();
    hide();
  }

  function showIfAllowed(message, duration) {
    if (stopped || drawerOpen) return;
    if (document.hidden) return; // tab backgrounded, just skip this turn
    show(message, duration);
  }

  function scheduleRepeat() {
    if (stopped) return;
    armPending(rand(REPEAT_MIN_MS, REPEAT_MAX_MS), function () {
      showIfAllowed(pickFirstMessage(), VISIBLE_MS);
      scheduleRepeat();
    });
  }

  function scheduleSecondAppearance(elapsedMs) {
    var remaining = Math.max(SECOND_DELAY_MS - elapsedMs, 0);
    armPending(remaining, function () {
      showIfAllowed(getSecondMessage(), SECOND_VISIBLE_MS);
      scheduleRepeat();
    });
  }

  function scheduleFirstAppearance() {
    var firstDelay = rand(FIRST_MIN_MS, FIRST_MAX_MS);
    armPending(firstDelay, function () {
      showIfAllowed(pickFirstMessage(), VISIBLE_MS);
      scheduleSecondAppearance(firstDelay);
    });
  }

  function wireDrawerListeners() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer || drawer.__grannyIdleMascotWired) return;
    drawer.__grannyIdleMascotWired = true;

    drawer.addEventListener('dialog:open', function () {
      drawerOpen = true;
      clearTimeout(visibleTimer);
      hide();
      pausePending();
    });

    drawer.addEventListener('dialog:close', function () {
      drawerOpen = false;
      resumePending();
    });
  }

  function init() {
    if (!getEls()) return;
    wireDrawerListeners();
    scheduleFirstAppearance();
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('.granny-idle-mascot__close')) {
      hide();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
